import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  root: {
    '&.MuiRadio-colorPrimary.Mui-checked': {
      color: 'inherit',
    },
    '&.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26) !important',
    },
    '& + .MuiFormControlLabel-label': {
      color: 'black',
    },
  },
});
